// filepath: apps/web/src/features/admin/PermissionsMatrixRoute.tsx
//
// FR-UI-ADM-1 AC-2 — route shell for the permission matrix editor.
//
// URL: /admin/permissions/matrix
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403 ENV_PRODUCTION on PUT /api/roles/{roleName}/permissions).

import React from "react";
import { PermissionsMatrixPage } from "./PermissionsMatrixPage";
import { StagingOnlyError } from "./StagingOnlyError";

interface PermissionsMatrixRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function PermissionsMatrixRoute({
  environmentKind,
}: PermissionsMatrixRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <PermissionsMatrixPage environmentKind={environmentKind} />;
}
